export default __webpack_public_path__ + "static/media/above_the_fold.80e46c83.png";